import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
})
export class CardComponent {
  @Input() section?: string;
  @Input() title!: string | number;
  @Input() align: string = 'left';
  @Input() padding: string = 'p-4';
  @Input() margin: string = 'm-1';
  @Input() backgroundColor: string = 'surface-card';
}
